import React, { memo } from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';
import {
  CheckSolidIcon,
  PhoneSolidIcon,
  TimesSolidIcon
} from '../../shared/icons/icons';

import styles from './product-availability-message.scss';

interface ProductAvailabilityMessageProps {
  availabilityMessage: string;
  availabilityMessageRank?: number;
  className?: string;
  hideIcons?: boolean;
  renderCheckIcon?: React.ReactElement;
  stockLevelCode?: string;
}

function ProductAvailabilityMessage(props: ProductAvailabilityMessageProps) {
  const {
    availabilityMessage,
    availabilityMessageRank,
    className,
    hideIcons = false,
    renderCheckIcon,
    stockLevelCode
  } = props;

  function getStockAvailabilityIcon() {
    const rank = availabilityMessageRank ?? 0;
    if (stockLevelCode === 'specialOrder') {
      return <PhoneSolidIcon className={styles['phone-icon']} />;
    } else if (rank > 5) {
      return <TimesSolidIcon className={styles['x-icon']} />;
    } else if (rank <= 5) {
      return renderCheckIcon ? (
        <>{renderCheckIcon}</>
      ) : (
        <CheckSolidIcon className={styles['check-icon']} />
      );
    }
    return (
      <div
        className={cn(
          styles['icon-hidden'],
          'product-availability-message__icon-hidden'
        )}
      />
    );
  }

  return (
    <Typography
      className={cn(
        styles['container'],
        `${className || ''} product-availability-message`
      )}
      tag="strong"
      weight="bold"
    >
      {!hideIcons && getStockAvailabilityIcon()}
      <span>{availabilityMessage?.replace('at My Store', '')}</span>
    </Typography>
  );
}

export default memo(ProductAvailabilityMessage);
